@import 'src/styles/common/_colors.scss';

.exceptionReportWrapper {
    height: 100%;
   
}

.modalWrapper {
    min-width: 450px;
    max-width: 450px !important;
    min-height: 450px;
}

.dialogHeader {
    align-items: center;
    justify-content: center;
}

.dialogBody {
    display: flex; 
    flex-direction: column; 
    gap: 5px;
    background-color: $report-dialog-pabel-color;
}

.accountsWrapper {
    padding: 5px 15px;
    background: linear-gradient(180deg, $smoke-black,$mightnight-black);
    border-radius: 2px 2px 0 0;
    border: 1px solid $gray;
}

.dialogFooter {
    button[class*="_buttonBlue_"] {
        margin-right: 10px;
        height: 24px;
        margin-top: 1px;
    }
}

.searchWrapper {
    padding: 5px 15px;
    background: linear-gradient(180deg,$smoke-black,$mightnight-black);
    border: 1px solid $gray;
    [class*="iconSearch"] {
        top: 7px !important;
    }
    [class*="clearInput"] {
        top: 14px !important;
    }
}

.buildingsWrapper {
    height: 260px;
    background-color: $gray;
    display: flex;
    flex-direction: column;
}

.border {
    border-bottom: 1px solid $orientation-icon-color;
}

.selectedWrapper {
    padding: 0px 5px 5px 5px;
}

.unSelectedWrapper {
    padding: 5px;
}
